<template>
  <div class="tw-text-sm font-normal">
    <!-- Numeric -->
    <template v-if="formatLabel === 'Number'">
      {{ storeAnswer.data.value }}
    </template>
    <!-- Percentage -->
    <template v-else-if="formatLabel === 'Percentage'">
      {{ storeAnswer.data.value }}%
    </template>
    <!-- Currency -->
    <template v-else-if="formatLabel === 'Currency'">
      ${{ storeAnswer.data.value }}
    </template>
    <!-- Fraction -->
    <template v-else-if="formatLabel === 'Fraction'">
      {{ storeAnswer.data.value1 }}:{{ storeAnswer.data.value2 }}
      <span class="muted" v-if="storeAnswer.data.value">
        ({{ storeAnswer.data.value }}%)
      </span>
    </template>
    <!-- Duration -->
    <template v-else-if="formatLabel === 'Duration'">
      <span v-if="storeAnswer.data.value1">{{ storeAnswer.data.value1 }}h</span>
      <span v-if="storeAnswer.data.value2">{{ storeAnswer.data.value2 }}m</span>
    </template>
    <!-- Default to Numeric -->
    <template v-else>
      {{ storeAnswer.data.value }}
    </template>
  </div>
</template>
<script>
import mixin from './_mixin_display'
export default {
  mixins: [mixin],
  computed: {
    formatLabel(){ return this.field.datahash.format?.label },
  }
}
</script>